import { usePublicLiveStore } from "./usePublicLiveStore";

export const usePublicLiveStoreActions = () =>
  usePublicLiveStore(state => state.actions);
